import { format } from "date-fns";
import CustomTableRow from "../table/CustomTableRow";
import React from "react";

export default function LogsTableRow({ row }) {
  return (
    <CustomTableRow
      columns={[
        {
          text: `${row.journeyId}`,
        },
        {
          text: row.applicationNo,
        },

        {
          text: row.logType,
        },
        
        {
          text: row.logMessage,
        },
        {
          text: format(new Date(row.CREATED_AT), "dd MMM yyyy, hh:mm a"),
        },
        
        { text: row.metadata ? "metaDta" : "-" },
      ]}
    ></CustomTableRow>
  );
}
